import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { Text } from "sprout-ui-primitives";
import { Button } from "sprout-ui-dom/dist/Button";
import { useBus } from "sprout-ui-dom/dist/Bus";
import { Page, Head } from "@sprout/client-layout";
import { Link } from "react-router-dom";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
const NotFound = ()=>{
    const eventBus = useBus();
    const currentUser = useCurrentUser();
    const handleLoginClick = useCallback(()=>{
        eventBus.emit("dialog::auth::open", false);
    }, [
        eventBus
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                title: "Page not found | Sprout"
            }),
            /*#__PURE__*/ _jsx(Page, {
                variant: "shadow",
                fullHeight: false,
                maxWidth: 600,
                children: /*#__PURE__*/ _jsxs(Text, {
                    textAlign: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            as: "h1",
                            fontSize: 5,
                            mt: "8px",
                            mb: "24px",
                            children: "Page not found"
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            as: "p",
                            mb: "48px",
                            children: "You may have mistyped the address or need to be invited to a topic"
                        }),
                        currentUser ? /*#__PURE__*/ _jsx(Button, {
                            variant: "bright-blue",
                            as: Link,
                            to: "/",
                            children: "Take me home"
                        }) : /*#__PURE__*/ _jsx(Button, {
                            variant: "bright-blue",
                            onClick: handleLoginClick,
                            children: "Login"
                        })
                    ]
                })
            })
        ]
    });
};
export default NotFound;
